/**
 * PROFESSIONAL SERVICES DOMAIN CONFIGURATION
 * Cấu hình cho lĩnh vực Dịch vụ chuyên nghiệp
 */
export const domainConfig = {
  // === BASIC INFO ===
  id: "professional",
  name: "Dịch vụ chuyên nghiệp",
  icon: "👔",
  description:
    "Tạo nội dung marketing cho luật sư, tư vấn, kế toán và các dịch vụ chuyên nghiệp",

  // === PROJECT TYPES ===
  projectTypes: {
    "Văn phòng luật": 1,
    "Công ty tư vấn": 2,
    "Dịch vụ kế toán": 3,
    "Kiểm toán": 4,
    "Tư vấn HR": 5,
    "Tư vấn IT": 6,
    "Tư vấn marketing": 7,
    "Dịch vụ công chứng": 8,
    "Tư vấn bất động sản": 9,
    "Dịch vụ đăng ký kinh doanh": 10,
  },

  // === CONTENT TYPES ===
  contentTypes: {
    "Giới thiệu dịch vụ": 1,
    "Kinh nghiệm chuyên môn": 2,
    "Case study thành công": 3,
    "Tư vấn miễn phí": 4,
    "Thông tin pháp lý": 5,
    "Hướng dẫn thủ tục": 6,
    "Câu hỏi thường gặp": 7,
    "Testimonial khách hàng": 8,
    "Báo giá dịch vụ": 9,
    "Tips chuyên môn": 10,
    "Cập nhật quy định": 11,
    "Event/Hội thảo": 12,
  },

  // === PUBLISHING PLATFORMS (Optional) ===
  publishingPlatforms: {
    // Để trống sẽ dùng shared platforms
  },

  // === DEFAULT VALUES ===
  defaults: {
    projectType: "Công ty tư vấn",
    contentType: "Giới thiệu dịch vụ",
    postLength: "Trung bình",
    postStyles: ["Chuyên nghiệp", "Đáng tin cậy"],
  },

  // === UI LABELS ===
  labels: {
    projectTypeLabel: "Loại dịch vụ chuyên nghiệp",
    contentTypeLabel: "Loại nội dung",
    projectInfoLabel: "Thông tin dịch vụ chuyên nghiệp",
    projectInfoPlaceholder:
      "Nhập thông tin chi tiết về dịch vụ, chuyên môn, kinh nghiệm, đội ngũ...",
    targetCustomerLabel: "Đối tượng khách hàng",
    targetCustomerPlaceholder:
      "Mô tả đối tượng khách hàng: doanh nghiệp, cá nhân, quy mô, ngành nghề...",
  },

  // === DOMAIN-SPECIFIC SETTINGS ===
  settings: {
    requiresLocation: true, // Địa điểm văn phòng quan trọng
    requiresPrice: true, // Báo giá dịch vụ
    requiresExperience: true, // Kinh nghiệm chuyên môn
    requiresLicense: true, // Giấy phép hành nghề
  },
};
